import styled from '@emotion/styled'

export const HeroBackground = styled.div`
    width: 100%;
    position: relative;
    margin-top: 108px;
    z-index: 0;
    background-color: ${(props) => props.theme.primaryColor.blue[1]};
    height: 272px;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        display: flex;
        flex-direction: column;
        height: unset;
        padding-bottom: 0px;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        padding-bottom: 0px;
    }
`

export const TextSide = styled.div`
    display: flex;
`

export const ImageWrapper = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 272px;
    object-fit: cover;
    z-index: 1;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        position: static;
        align-self: flex-end;
        width: 100%;
    }
`

export const Background = styled.div`
    display: flex;
    height: 400px;
    background-color: ${(props) => props.theme.primaryColor.white[1]};
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.primaryColor.blue[3]};
`

const HeroHeader = styled.div`
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.primaryColor.grey[1]};
`

export const HeroMainHeader = styled(HeroHeader)`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    max-width: ${(props) => props.theme.containerWidth};
    color: ${(props) => props.theme.primaryColor.white[1]};
    position: relative;
    z-index: 2;
    margin: 20px auto 0 auto;
    gap: 16px;
    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        justify-content: center;
        align-items: center;
    }
`

export const HeroContent = styled.div`
    display: flex;
    flex-direction: row;
    gap: 32px;
    align-items: center;
    padding: 64px 0px;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        // padding: 64px;
    }
`
